import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    
    this.onCatch = props.onCatch;

    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error,info) {
    // Update state so the next render will show the fallback UI.
    debugger;
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({
      error:error.message,
      componentStack:errorInfo.componentStack
    });
    console.log(errorInfo.componentStack);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{textAlign:'center'}} class="full-height full-width fair-padding">
          <h1>Something went wrong.</h1>
          <h4>{this.state.error}</h4>
          <div>
            <pre>
            {this.state.componentStack}
            </pre>
          </div>
        </div>
      );
    }

    return this.props.children; 
  }
}
